import React, { useState, useEffect } from 'react';
import PageRenderer from '../components/renderer/PageRenderer';
import SettingsLoader from '../components/common/SettingsLoader';
import { useAuth0 } from '@auth0/auth0-react';
import { apiPath } from "../config";
import { Container, Row } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import MainAppWrap from '../Layout/MainAppWrap';
import SimpleHeader from '../components/SimpleHeader';
import Footer from '../components/Footer';

interface Schema {
    header?: {
        logo_url?: string;
        title?: string;
    };
    aiChat?: boolean;
    [key: string]: any;
}

const DealRooms: React.FC = () => {
    const { user, getIdTokenClaims } = useAuth0();
    
    const [schema, setSchema] = useState<Schema | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isChatOpen, setIsChatOpen] = useState<boolean>(false);
    const [showChat, setShowChat] = useState<boolean>(false);
    
    const getDealRoomsSchema = async (): Promise<void> => {
        try {
            const getidToken = await getIdTokenClaims();
            const idToken = getidToken?.__raw;
            const options: RequestInit = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${idToken}`,
                    "Content-Type": "application/json",
                },
            };
            const path = `/admin/v1/pages/read/dr_admin`;
            const url = `${apiPath()}${path}`;
            const response = await fetch(url, options);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const result = await response.json();
            setSchema(result);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching deal rooms schema:', error);
        }
    };

    useEffect(() => {
        if (user) {
            setIsLoading(true);
            setSchema(null);
            getDealRoomsSchema();
        }
    }, [user]);

    const mainContentClassName = `main-content${isChatOpen ? ' chat-open' : ''}`;

    return (
        <div>
            <MainAppWrap>
                <div className={mainContentClassName}>
                    {/* Header Section */}
                    {schema?.header ? (
                        <SimpleHeader logo={schema?.header?.logo_url} title={schema?.header?.title} />
                    ) : (
                        <SimpleHeader />
                    )}
                    <Container fluid="xxl" className="">
                        <Row>
                            <div className="page-container">
                                {isLoading ? <SettingsLoader /> : <PageRenderer schema={schema} />}
                            </div>
                        </Row>
                    </Container>
                    {(schema?.aiChat || showChat) && (
                        <div className={`chat-panel ${isChatOpen ? 'open' : ''}`}>
                            <button 
                                className="chat-toggle-btn"
                                onClick={() => setIsChatOpen(!isChatOpen)}
                                aria-label={isChatOpen ? 'Close Chat' : 'Open Chat'}
                            >
                                {/* <GenerateIcon /> */}
                            </button>
                            {/* <EptSystemChat /> */}
                        </div>
                    )}
                </div>
                <ToastContainer />
                <Footer />
            </MainAppWrap>
        </div>
    );
};

export default DealRooms;
